'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { SearchParams } from '@/entities/SearchParams';
interface NavigationTabsProps {
	searchParams: SearchParams;
}
export const NavigationTabs = ({ searchParams }: NavigationTabsProps) => {
	const pathname = usePathname();
	const tabs = [
		{ name: 'My stats', param: undefined },
		{ name: 'My transactions', param: `transactions` },
		{ name: 'My availability', param: `availability` }
	];
	return (
		<div className="flex justify-between  pb-14 pt-12 sm:justify-normal sm:space-x-4">
			{tabs.map((tab) => {
				const isActive = searchParams?.page === tab.param;
				return (
					<Link key={tab.name} href={`${pathname}${tab.param ? `?page=${tab.param}` : ''}`}>
						<div
							className={`relative cursor-pointer p-2 text-sm font-medium sm:px-4 ${
								isActive ? 'border-b-2 border-b-darkorange-400 text-darkorange-400' : 'text-gray-500 hover:text-gray-700'
							}`}
						>
							{tab.name}
						</div>
					</Link>
				);
			})}
		</div>
	);
};
